import { Component, ChangeDetectionStrategy, inject, signal, input, output } from "@angular/core";
import { NavItems, GlossRoutes } from "../../../models/enum/routes.enum";
import { Menu } from "@bitwarden/web-vault/app/layouts/menu/menu";
import { MonthlySummaryService } from "@bitwarden/web-vault/app/services/monthly-summary/monthly-summary.service";

@Component({
  selector: "app-side-menu",
  templateUrl: "./side-menu.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideMenuComponent extends Menu {
  selectedKeyInput = input<string>(GlossRoutes.Views.toString());
  openHelpBoxEvent = output<void>();
  private monthlySummaryService = inject(MonthlySummaryService);

  protected readonly process = process;
  protected readonly GlossRoutes = GlossRoutes;
  protected readonly settingsRoleScope = NavItems.find((item) => item.key === GlossRoutes.Settings)
    ?.roleScope;
  protected readonly navRowClass =
    "tw-flex tw-h-[48px] tw-items-center tw-gap-2 tw-px-3 tw-rounded-xl tw-border tw-border-solid tw-border-transparent hover:tw-bg-black/[0.08] dark:hover:tw-bg-white/[0.08] tw-cursor-pointer tw-transition-colors";

  navItems = NavItems;
  // Expose navItems as signal to parent class for itemSignalStates computed
  protected menuItemsSignal = signal(NavItems);

  constructor() {
    super();
    // Initialize selected key from input
    this.selectedKey.set(this.selectedKeyInput());
  }

  openHelpBox() {
    this.openHelpBoxEvent.emit();
  }

  protected monthlySummaryEnabled(): boolean {
    return this.monthlySummaryService.enabled;
  }

  openMonthlySummary(): void {
    void this.monthlySummaryService.open();
  }
}
